import axios, { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import { applyIamAuthHeaders } from './applyIamAuthHeaders'
import { getEngineApiBaseUrl } from '@/config/engineApiBaseUrl'
import { API_TIMEOUT_MS } from '@/api/timeouts'

const engineClient: AxiosInstance = axios.create({
  baseURL: getEngineApiBaseUrl(),
  timeout: API_TIMEOUT_MS,
  headers: { 'Content-Type': 'application/json', accept: 'application/json' },
  withCredentials: true,
})

engineClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  config.baseURL = getEngineApiBaseUrl()
  applyIamAuthHeaders(config)
  return config
})

engineClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const data = error.response?.data as Record<string, unknown> | undefined
    const errors = Array.isArray(data?.errors) ? data.errors : undefined
    const results = Array.isArray(data?.results) ? data.results : undefined
    const firstBatchError =
      Array.isArray(errors) && errors.length > 0
        ? (errors[0] as { error?: string; code?: string })
        : undefined
    const bodyText =
      (typeof data?.message === 'string' && data.message) ||
      (typeof data?.error === 'string' && data.error) ||
      (typeof firstBatchError?.error === 'string' && firstBatchError.error) ||
      ''
    const statusCode = error.response?.status
    const raw = bodyText || error.message || 'Engine request failed'
    const code =
      (typeof data?.error === 'string' && data.error) ||
      (typeof firstBatchError?.code === 'string' && firstBatchError.code) ||
      undefined

    return Promise.reject({
      message: raw,
      statusCode,
      code,
      details: data?.details,
      errors,
      results,
    })
  }
)

export default engineClient
